/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CostResponse } from '../models/CostResponse';
import type { Grade } from '../models/Grade';
import type { Period } from '../models/Period';
import type { RatesAndBrackets } from '../models/RatesAndBrackets';
import type { Salary } from '../models/Salary';
import type { Scheme } from '../models/Scheme';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class V1AlphaService {
    /**
     *
     * Calculates the full cost of employment including things like
     * tax, NI, and pension contributions
     *
     * Retrieve the cost
     * @param pointValueFte Base salary to be used in calculation
     * @param scheme Pension scheme value (see /v1alpha/schemes/ for valid options)
     * @returns CostResponse
     * @throws ApiError
     */
    public static v1AlphaCostRetrieve(
        pointValueFte: number,
        scheme?: string,
    ): CancelablePromise<CostResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1alpha/cost',
            query: {
                'point_value_fte': pointValueFte,
                'scheme': scheme,
            },
        });
    }
    /**
     * List Grades
     * Lists available grades
     * @returns Grade
     * @throws ApiError
     */
    public static v1AlphaGradesList(): CancelablePromise<Array<Grade>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1alpha/grades',
        });
    }
    /**
     * List Periods
     * Lists available periods
     * @returns Period
     * @throws ApiError
     */
    public static v1AlphaPeriodsList(): CancelablePromise<Array<Period>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1alpha/periods',
        });
    }
    /**
     * Retrieve Rates and Brackets
     * Retrieves rates and brackets
     * @param period Period value (see /v1alpha/periods/ for valid options)
     * @param scheme Pension scheme value (see /v1alpha/schemes/ for valid options)
     * @returns RatesAndBrackets
     * @throws ApiError
     */
    public static v1AlphaRatesAndBracketsRetrieve(
        period: string,
        scheme: string,
    ): CancelablePromise<RatesAndBrackets> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1alpha/rates-and-brackets',
            query: {
                'period': period,
                'scheme': scheme,
            },
        });
    }
    /**
     * List Salaries
     * Lists available salaries
     * @param grade Grade value (see /v1alpha/grades/ for valid options)
     * @param period Period value (see /v1alpha/periods/ for valid options)
     * @param scheme Pension scheme value (see /v1alpha/schemes/ for valid options)
     * @returns Salary
     * @throws ApiError
     */
    public static v1AlphaSalariesList(
        grade: string,
        period: string,
        scheme: string,
    ): CancelablePromise<Array<Salary>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1alpha/salaries',
            query: {
                'grade': grade,
                'period': period,
                'scheme': scheme,
            },
        });
    }
    /**
     * List Schemes
     * Lists available schemes
     * @returns Scheme
     * @throws ApiError
     */
    public static v1AlphaSchemesList(): CancelablePromise<Array<Scheme>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1alpha/schemes',
        });
    }
}
